import type { LeadStatus } from '@conversia/shared-types';
import type { Faceta } from './superfiltro';

/** Pestañas de la bandeja: temperatura (compradores) + bandejas aparte por tipo. PURO. */
export const PESTANAS: { valor: string; etiqueta: string }[] = [
  { valor: '', etiqueta: 'Todas' },
  { valor: '__ATTN', etiqueta: 'Atención' },
  { valor: 'CALIENTE', etiqueta: 'Caliente' },
  { valor: 'TIBIO', etiqueta: 'Tibio' },
  { valor: 'FRIO', etiqueta: 'Frío' },
  { valor: 'LARGO_PLAZO', etiqueta: 'Largo plazo' },
  { valor: 'TIPO:realtor', etiqueta: 'Aliados' },
  { valor: 'TIPO:vendedor', etiqueta: 'Listings' },
  { valor: 'TIPO:lujo', etiqueta: 'Lujo' },
  { valor: 'CERRADO', etiqueta: 'Cerrado' },
  { valor: 'NO_CERRADO', etiqueta: 'No cerrado' },
];

export function filtrosDePestana(valor: string): { leadStatus?: LeadStatus; tipoContacto?: string; status?: 'WAITING_HUMAN' } {
  if (!valor) return {};
  if (valor === '__ATTN') return { status: 'WAITING_HUMAN' };
  if (valor.startsWith('TIPO:')) return { tipoContacto: valor.slice(5) };
  return { leadStatus: valor as LeadStatus };
}

/** Pestaña activa: la explícita, o la derivada de los filtros (p. ej. store con filtros pero sin `pestana`). */
export function pestanaActiva(f: { pestana?: string; status?: string; leadStatus?: string; tipoContacto?: string }): string {
  if (f.pestana !== undefined) return f.pestana;
  if (f.status === 'WAITING_HUMAN') return '__ATTN';
  if (f.tipoContacto) return 'TIPO:' + f.tipoContacto;
  return f.leadStatus ?? '';
}

/** Qué conversaciones: todas, individuales o grupos. */
export const TIPOS_DE_CHAT: { value: 'all' | 'individual' | 'group'; label: string }[] = [
  { value: 'all', label: 'Todas' },
  { value: 'individual', label: 'Individuales' },
  { value: 'group', label: 'Grupos' },
];

/** Las claves de la bandeja en la URL (`/conversations?bandeja=CALIENTE&canal=…`). */
export const FILTROS_DE_LA_BANDEJA = { bandeja: '', tipo: '', canal: '', buscar: '' };
/** Un valor raro en la URL no filtra en secreto: cae a «todas». */
export const VALIDOS_DE_LA_BANDEJA = { bandeja: PESTANAS.map((p) => p.valor), tipo: ['individual', 'group'] };

/** Las facetas del superfiltro de Chats: bandeja, tipo de chat y canal. PURO. */
export function facetasDeLaBandeja(canales: { id: string; nombre: string }[]): Faceta[] {
  return [
    { clave: 'bandeja', titulo: 'Bandeja', todas: 'Todas', opciones: PESTANAS.filter((p) => p.valor).map((p) => ({ valor: p.valor, etiqueta: p.etiqueta })) },
    { clave: 'tipo', titulo: 'Tipo', todas: 'Todas', opciones: TIPOS_DE_CHAT.filter((t) => t.value !== 'all').map((t) => ({ valor: t.value, etiqueta: t.label })) },
    ...(canales.length > 0 ? [{ clave: 'canal', titulo: 'Canal', opciones: canales.map((c) => ({ valor: c.id, etiqueta: c.nombre })) }] : []),
  ];
}

/**
 * Lo que dice el botón «Filtro» de Chats de lo que está puesto (6-oct, Kervens: los filtros
 * van dentro de un botón que se despliega, debajo de la búsqueda). null = ninguno. PURO.
 */
export function resumenDeFiltros(
  f: { pestana?: string; leadStatus?: string; tipoContacto?: string; status?: string; type?: string; channelId?: string },
  canales: { id: string; name: string }[] = [],
): string | null {
  const partes: string[] = [];
  const pestana = PESTANAS.find((p) => p.valor === pestanaActiva(f));
  if (pestana && pestana.valor) partes.push(pestana.etiqueta);
  const tipo = TIPOS_DE_CHAT.find((t) => t.value === f.type);
  if (tipo && tipo.value !== 'all') partes.push(tipo.label);
  if (f.channelId) partes.push(canales.find((c) => c.id === f.channelId)?.name ?? 'Un canal');
  return partes.length ? partes.join(' · ') : null;
}
